
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowBottomRight as ObiArrowBottomRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-bottom-right.js';
 
 
 

 
 export const ObiArrowBottomRight = createComponent({
   react: React,
   tagName: 'obi-arrow-bottom-right',
   elementClass: ObiArrowBottomRightElement,
   events: {
     
   }
  });
 
 